import React from "react";
import { Link } from "react-router-dom";
import { CONTACT } from "../lib/brand";

export const SiteFooter = () => {
  return (
    <footer className="border-t border-[#cfd7db] bg-[#20282c] text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-12 grid grid-cols-1 md:grid-cols-3 gap-10 text-sm">
        <div>
          <div className="font-display font-black text-white uppercase tracking-tight text-2xl">
            Diesel <span className="text-[#ffc438]">&</span> Dust Group
          </div>
          <p className="text-[#cfd7db] mt-4 leading-relaxed">
            Mobile windscreen specialists. Insurance-approved. SABS-approved
            glass. Fast, friendly, professional service across South Africa.
          </p>
        </div>

        <div>
          <div className="font-display uppercase tracking-widest text-xs text-[#ffc438] mb-3">
            Contact
          </div>
          <ul className="space-y-2 text-white/90">
            <li>
              <a href={`tel:${CONTACT.phone}`} className="hover:text-[#ffc438]" data-testid="footer-phone">
                {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={`https://wa.me/${CONTACT.whatsapp.replace(/[^0-9]/g, "")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#ffc438]"
                data-testid="footer-whatsapp"
              >
                WhatsApp: {CONTACT.whatsappDisplay}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} className="hover:text-[#ffc438]" data-testid="footer-email">
                {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="font-display uppercase tracking-widest text-xs text-[#ffc438] mb-3">
            Legal
          </div>
          <p className="text-[#cfd7db] leading-relaxed">
            Terms and conditions apply. Quotes are subject to inspection and
            confirmation of vehicle details. Insurance excess and approvals
            apply where relevant.
          </p>
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="inline-block mt-3 font-display uppercase tracking-widest text-xs text-[#ffc438] hover:text-white transition border-b border-[#ffc438]/50 hover:border-white pb-0.5"
          >
            Read full Terms &amp; Conditions →
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-[#9aa6ad]">
        © {new Date().getFullYear()} Diesel & Dust Group. All rights reserved.
      </div>
    </footer>
  );
};

export default SiteFooter;
